import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

interface AgencyFeatures {
  showRewards: boolean;
  showWOpsAdminTabs: boolean;
  agencyName: string;
  loading: boolean;
}

export function useAgencyFeatures(): AgencyFeatures {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['agency-features', user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('agency_members')
        .select('agency:agencies(name, show_rewards, show_wops_admin_tabs)')
        .eq('user_id', user!.id)
        .limit(1)
        .maybeSingle();

      if (error || !data?.agency) {
        return { showRewards: false, showWOpsAdminTabs: false, agencyName: '' };
      }

      const agency = data.agency as unknown as { name: string; show_rewards: boolean; show_wops_admin_tabs: boolean };
      return {
        showRewards: agency.show_rewards ?? false,
        showWOpsAdminTabs: agency.show_wops_admin_tabs ?? false,
        agencyName: agency.name ?? '',
      };
    },
  });

  return {
    showRewards: data?.showRewards ?? false,
    showWOpsAdminTabs: data?.showWOpsAdminTabs ?? false,
    agencyName: data?.agencyName ?? '',
    loading: isLoading,
  };
}
